import * as axios from 'axios';

const BASE_URL = `${process.env.VUE_APP_API_URL}`;

function upload(formData, params) {
    var url = `${BASE_URL}/uploadsImg`;
    const paramJson = new URLSearchParams();
    for (const param in params) {
        paramJson.append(param, params[param]);
    }
    return axios.post(url, formData, {
        params: paramJson
    })
        // get data
        .then(x => x.data)
        // add url field
        .then(img => Object.assign({},
            img, { url: `${BASE_URL}/images/${img.cloudUrl}` }));
}
export { upload }